import { PiralPlugin } from "piral-core";
import { FeatureToggle } from "../models/FeatureToggle";
import { FeatureToggleService } from "../service/FeatureToggleService";

export interface PiletFeatureToggleApi {
  allFeaturesToggle: () => FeatureToggle[];
  getFeatureToggle: (name: string) => Promise<boolean>;
}

export function createPiletFeatureToggleApi(apiUrl: string, allFeaturesToggle: FeatureToggle[]) : PiletFeatureToggleApi {
  const piletFeatureToggleApi: PiletFeatureToggleApi = {
    allFeaturesToggle: () => allFeaturesToggle,
    getFeatureToggle: (name: string) => {
      const service = new FeatureToggleService(apiUrl);
      return service.getFeatureToggle(name);
    }
  };

  return piletFeatureToggleApi;
}

export function createFeatureToggleApi<T extends PiletFeatureToggleApi>(
  featureToggleApi: T,
): PiralPlugin<T> {
  return (_context) =>
    (_api, _target): T => (featureToggleApi);
}
